<template>
    <div>
        <div
            class="mt-8 rounded-lg p-4 border"
            :class="[
                enabled
                    ? 'border-z-primary-500 bg-z-primary-25'
                    : 'border-iron-200',
            ]"
        >
            <div class="gap-2.5 flex">
                <Switch v-model:checked="enabled" class="mt-1" />
                <div>
                    <p class="text-sm font-medium text-iron-700">
                        {{ $t("event_types.guests.title") }}
                    </p>
                    <p class="text-sm text-iron-500">
                        {{ $t("event_types.guests.description") }}
                    </p>
                </div>
            </div>

            <div v-if="enabled" v-auto-animate class="mt-4 pl-[54px]">
                <div class="max-w-sm gap-1 grid w-full">
                    <Label for="maxGuests">{{
                        $t("event_types.guests.max_guests")
                    }}</Label>
                    <Input
                        id="maxGuests"
                        v-model="maxGuests"
                        type="number"
                        min="1"
                        max="100"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { EventType } from "../types/EventType";
import { ref, watch } from "vue";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { vAutoAnimate } from "@formkit/auto-animate";
import { debouncedWatch } from "@vueuse/core";

interface Props {
    eventType: EventType;
}

const props = defineProps<Props>();

const enabled = ref(props.eventType.max_guests !== null);
const maxGuests = ref(props.eventType.max_guests ?? 5);

watch(enabled, () => {
    save();
});

debouncedWatch(
    maxGuests,
    () => {
        if (enabled.value) {
            save();
        }
    },
    {
        debounce: 500,
    },
);

function save() {
    router.put(
        route("app.event-types.max-guests.update", {
            eventType: props.eventType.id,
        }),
        {
            enabled: enabled.value,
            max_guests: maxGuests.value,
        },
    );
}
</script>
